import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
		iconfont: 'md'
	},
	theme: {
		themes: {
			light: {
				primary: '#CC2128',
				primaryHover: '#AF1D21',
				background: '#FFF',
				promocao: '#CCC935',
				texto: "#000",
				textoBotoes: '#FFF',
				textoPromocao: '#FFF',
				textoPrecoAntigo : '#808080'

			},
		},
		options: {
			customProperties: true
		}
	}
})
